"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.snakeCaseToSlides = void 0;
function snakeCaseToSlides(text) {
    return text.replace("_", " / ");
}
exports.snakeCaseToSlides = snakeCaseToSlides;
